import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useAtom } from "jotai";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { DebugType, debugSettingSelector, } from "@plansoft-configuration-renderer/debug";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function DebugOptionsSelector(props) {
    const t = useUiTranslator();
    const { hiddenOptions = [] } = props;
    const options = {
        // [DebugType.Debug]: useRecoilState(debugSettingSelector(DebugType.Debug)),
        [DebugType.Configuration]: useAtom(debugSettingSelector(DebugType.Configuration)),
        [DebugType.Attributes]: useAtom(debugSettingSelector(DebugType.Attributes)),
        [DebugType.Values]: useAtom(debugSettingSelector(DebugType.Values)),
        [DebugType.Groups]: useAtom(debugSettingSelector(DebugType.Groups)),
        [DebugType.Layout]: useAtom(debugSettingSelector(DebugType.Layout)),
        [DebugType.Other]: useAtom(debugSettingSelector(DebugType.Other)),
    };
    const labels = useConfigurationDebugOptionLabels();
    const visibleOptions = Object.entries(options).filter((option) => !hiddenOptions.includes(option[0]));
    return (_jsxs(Stack, { sx: { m: 1, minWidth: 120 }, spacing: 0, children: [_jsx(FormLabel, { children: t("ConfigurationRenderer:DebugOptionsSelector.title", "Debug information") }), _jsx(_Fragment, { children: visibleOptions.map(([option, [checked, setChecked]]) => (_jsx(FormGroup, { children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: checked, onChange: () => setChecked(!checked) }), label: _jsx(Fragment, { children: labels[option] }) }) }, option))) })] }));
}
function useConfigurationDebugOptionLabels() {
    const t = useUiTranslator();
    return {
        [DebugType.Debug]: t("ConfigurationRenderer:DebugOptions.Debug", "Debug"),
        [DebugType.Configuration]: t("ConfigurationRenderer:DebugOptions.Configuration", "Configuration"),
        [DebugType.Attributes]: t("ConfigurationRenderer:DebugOptions.Attributes", "Attributes"),
        [DebugType.Values]: t("ConfigurationRenderer:DebugOptions.Values", "Values"),
        [DebugType.Groups]: t("ConfigurationRenderer:DebugOptions.Groups", "Groups"),
        [DebugType.Layout]: t("ConfigurationRenderer:DebugOptions.Layout", "Layout"),
        [DebugType.Other]: t("ConfigurationRenderer:DebugOptions.Other", "Other"),
    };
}
//# sourceMappingURL=DebugOptionsSelector.js.map